import { render, staticRenderFns } from "./BranchReport.vue?vue&type=template&id=5361b150&"
import script from "./BranchReport.vue?vue&type=script&lang=js&"
export * from "./BranchReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports